<div class="ui card fluid">
  <div class="content">
    <h2 class="center aligned header">
      {{ modal.context.title }}
    </h2>
    <div class="ui section divider"></div>
    <div class="center aligned description">
      {{ modal.context.message }}
    </div>
  </div>
  <div class="extra content">
    <div class="actions center aligned">
      <button class="ui blue button" (click)="modal.deny()">Cancel</button>
      <button class="ui violet button" (click)="modal.approve()" autofocus>
        Confirm
      </button>
    </div>
  </div>
</div>
